import { render, staticRenderFns } from "./ShoppingDetail.vue?vue&type=template&id=e525964a&"
import script from "./ShoppingDetail.vue?vue&type=script&lang=js&"
export * from "./ShoppingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports